import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';

const StyledBeadcrumb = styled.div`
  display: flex;
  align-items: baseline;
  margin: 0 ${rem('15px')} ${rem('20px')};
  font-size: ${rem('16px')};
  flex-wrap: wrap;
  line-height: 1.2;
  .primary:hover {
    color: ${props => props.theme.colors.primary};
    cursor: pointer;
  }
`;

const StyledBeadcrumbIcon = styled(Icon)`
  width: ${rem('6px')};
  height: ${rem('12px')};
  margin: 0 ${rem('7px')};
`;
const StyledBeadcrumbPrimary = styled.span`
  font-weight: bold;
`;

export { StyledBeadcrumb, StyledBeadcrumbIcon, StyledBeadcrumbPrimary };
